import { render, staticRenderFns } from "./Manufacturers.vue?vue&type=template&id=8c07eeee&scoped=true&"
import script from "./Manufacturers.vue?vue&type=script&lang=js&"
export * from "./Manufacturers.vue?vue&type=script&lang=js&"
import style0 from "./Manufacturers.vue?vue&type=style&index=0&id=8c07eeee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c07eeee",
  null
  
)

export default component.exports